import { DataController } from "webrtc-player/webrtc_controller/data_controller";
import { batchObtainCredentials } from "lib/actions";
import { Signal } from "webrtc-player/common/signal";
import { WebRTC } from "webrtc-player/webrtc/webrtc";
import {
  DataWebRTC,
  DeviceSnapshotType,
} from "webrtc-player/webrtc/data_webrtc";
import { ENV, DB_STORE } from "./constants";
import { errorHandler } from "lib/utils";
import type { SnapshotDataTypes } from "pages/service";

export type Credential = {
  deviceId: string;
  token: string;
  turn: object;
};
const retryLimit = 3;
export class DataControllerContainer {
  public expiredTime: number = 0;
  public intermediateStateSet: string[] = [];
  public retryTimes: number = 0;
  public connected: boolean = false;
  public dataControler: DataController;
  public eventType?: string;
  public nvrId: number;
  public orgId?: string;
  constructor(dataControler, nvrId, orgId?) {
    this.dataControler = dataControler;
    this.nvrId = nvrId;
    this.expiredTime = new Date().getTime() + 1000 * 60 * 1;
    this.orgId = orgId;
  }
}

class DataControllerManager {
  private timer?: any;
  public static sessionId: string;
  public static orgId: string;
  public static signal: Signal;
  public static getDb;
  public dataCredentials: Credential[] = [];
  private connectingController: Map<number, Promise<DataController>> = new Map<
    number,
    Promise<DataController>
  >();
  private dataControlers: Map<number, DataControllerContainer> = new Map<
    number,
    DataControllerContainer
  >(); // key: nvrId

  private executableMap: Map<string, () => Promise<any>> = new Map<
    string,
    () => Promise<any>
  >(); // key: nvrid + function name
  private waitingMap: Map<string, (() => Promise<any>)[]> = new Map<
    string,
    (() => Promise<any>)[]
  >();
  private executingKeys: string[] = [];

  constructor() {
    this.setTimer();
    this.asyncGetDataController.bind(this);
  }
  private setTimer() {
    //this.clearInterval()
    this.timer = setInterval(() => {
      this.doLoopClose();
    }, 5000);
    // this.timer = setInterval(() => {
    //   this.doLoopExecutableTask();
    // }, 2000);
  }
  doLoopClose() {
    console.debug(
      "check living nvr data connection,size:",
      this.dataControlers.size,
    );
    if (this.dataControlers.size < 10) {
      return;
    }
    for (const [nvrId, data] of this.dataControlers) {
      if (data.expiredTime < Date.now()) {
        this.removeDataController(nvrId);
      }
    }
  }
  async subscribeCredentialsReady(nvrIds: number[], orgId?) {
    const newCredentialNvrIds = nvrIds.filter(
      (nvrId) =>
        !this.dataCredentials.find(
          (credential) =>
            +credential.deviceId === nvrId &&
            !this.credentialTokenExpired(credential),
        ),
    );
    if (newCredentialNvrIds?.length > 0) {
      // let cookieOrgId = Cookies.get("orgId");
      // if (cookieOrgId === "undefined") cookieOrgId = null;
      try {
        const res = await batchObtainCredentials(
          orgId || DataControllerManager.orgId,
          DataControllerManager.sessionId,
          newCredentialNvrIds,
        );
        if (!res || !Array.isArray(res.tokens)) {
          throw new Error("Invalid response");
        }
        this.dataCredentials.push(...res.tokens);
      } catch (error) {
        console.error("error to fetch credentials", error);
        //throw new Error("error to fetch credentials");
        return;
      }
    }
    const credentials: Credential[] = [];
    nvrIds?.forEach((nvrId) => {
      this.dataCredentials.find((Credential) => {
        if (+Credential.deviceId === nvrId) {
          credentials.push(Credential);
          return true;
        }
        return false;
      });
    });
    return credentials;
  }
  refreshExpiredTime(nvrId: number) {
    const expiredTime = Date.now() + 1000 * 30 * 1;
    if (this.dataControlers.get(nvrId)) {
      this.dataControlers.get(nvrId).expiredTime = expiredTime;
    }
  }

  waitForQueen(controller: DataController, property, arg) {
    if (typeof controller?.[property] !== "function") {
      return;
    }
    const nvrId = controller?.nvrId;
    const key = nvrId + property + "";
    const createTask = () => {
      return new Promise((resolve, reject) => {
        console.log("---start task", arg);
        const argArr = [...arg];
        const callBackIndex = argArr?.findIndex((a) => typeof a == "function");
        if (callBackIndex >= 0) {
          const newCallback = (...callbackArg) => {
            [...arg]?.find((a) => typeof a == "function")?.(...callbackArg);
            resolve(void 0);
            console.log("---start task fininshed");
            this.executingKeys = this.executingKeys?.filter((e) => e != key);
            this.executableMap.set(key, null);
            const queen = this.waitingMap.get(key);
            if (queen?.length > 0) {
              const doNewTask = queen?.shift();
              this.executableMap.set(key, doNewTask);
              doNewTask();
            }
          };
          argArr[callBackIndex] = newCallback;
        }
        const error = controller[property](...argArr);
        if (error) {
          console.log("---task failed", error);
          reject(error);
          this.executingKeys = this.executingKeys?.filter((e) => e != key);
          this.executableMap.set(key, null);
          const queen = this.waitingMap.get(key);
          if (queen?.length > 0) {
            const doNewTask = queen?.shift();
            this.executableMap.set(key, doNewTask);
            doNewTask();
          }
        }
      });
    };

    if (!this.executableMap?.get(key)) {
      // 加入到执行队列,
      this.executableMap.set(key, createTask);
      createTask();
      return;
    }
    // 加入等待队列
    const originTask = this.waitingMap.get(key) || [];
    originTask.push(createTask);
    this.waitingMap.set(key, originTask);
  }

  // doLoopExecutableTask() {
  //   for (const [key, value] of this.executableMap) {
  //     console.log(key, value);
  //     if (!this.executingKeys?.includes(key)) {
  //       this.executingKeys.push(key);
  //       value?.();
  //     }
  //   }
  // }

  getProxyDataControler(dataControlerContainer: DataControllerContainer) {
    const that = this;
    const handler = {
      get: function (target, property) {
        // console.log("getProxyDataControler", property);
        //set orgId of Container
        if (property === "orgId") {
          return target[property];
        }
        if (property === "webRTC" || property === "stats") {
          that.refreshExpiredTime(dataControlerContainer.nvrId);
          return target.dataControler[property];
        }
        if (property === "then") {
          return target.dataControler[property];
        }
        if (!dataControlerContainer.dataControler.webRTC.isConnected()) {
          return async function () {
            try {
              const controller = await that.createDataController(
                dataControlerContainer.nvrId,
                dataControlerContainer.orgId,
              );
              target.dataControler = controller;
              that.refreshExpiredTime(dataControlerContainer.nvrId);
              if (property === "deviceTakeSnapshots") {
                return that.waitForQueen(controller, property, arguments);
              }
              return controller[property](...arguments);
            } catch (e) {
              console.error(e);
            }
          };
        }
        if (property === "deviceTakeSnapshots") {
          return function () {
            return that.waitForQueen(
              target?.dataControler,
              property,
              arguments,
            );
          };
        }
        that.refreshExpiredTime(dataControlerContainer.nvrId);
        return target?.dataControler[property];
      },
    };
    const tmp = dataControlerContainer as unknown;
    const proxy = new Proxy<DataController>(tmp as DataController, handler);

    return proxy;
  }

  asyncGetDataController(
    nvrId: number,
    orgId?: string,
  ): Promise<DataController> {
    const findDataControler = this.dataControlers.get(nvrId);
    return new Promise(async (resolve, reject) => {
      if (findDataControler) {
        //controller exist
        this.refreshExpiredTime(nvrId);
        resolve(this.getProxyDataControler(findDataControler));
      } else {
        try {
          //create new controller
          const controller = await this.createDataController(nvrId, orgId);
          const newContainer = new DataControllerContainer(
            controller,
            nvrId,
            orgId,
          );
          this.dataControlers.set(nvrId, newContainer);
          resolve(this.getProxyDataControler(newContainer));
        } catch (e) {
          console.error(e);
          reject(e);
        }
      }
    });
  }

  removeDataController(nvrId: number) {
    const controler = this.dataControlers.get(nvrId)?.dataControler;
    controler?.close();
    this.dataControlers.delete(nvrId);
  }
  clearDataControllers() {
    for (const [nvrId] of this.dataControlers) {
      this.removeDataController(nvrId);
    }
  }
  credentialTokenExpired(Credential: Credential) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const token = Credential.token;
    //TODO JWT parse token and check if it is expired
    return false;
  }

  snapshotToDb(camera: DeviceSnapshotType) {
    console.log("lzctest:Receive snapshotToDb", camera.camera?.id);
    return new Promise<SnapshotDataTypes>(async (resolve, reject) => {
      if (
        camera.snapshot.imageBitmap &&
        camera.snapshot.imageBitmap.width > 0
      ) {
        const canvas = document.createElement("canvas");
        const width = (canvas.width = camera.snapshot.imageBitmap.width);
        const height = (canvas.height = camera.snapshot.imageBitmap.height);
        const context = canvas.getContext("bitmaprenderer");
        const newImageBitmap = await createImageBitmap(
          camera.snapshot.imageBitmap,
        );
        context.transferFromImageBitmap(newImageBitmap);
        canvas.toBlob(async (blob) => {
          resolve({
            blob,
            id: camera?.camera?.id,
            macAddress: camera?.camera?.macAddress,
            remoteIndex: camera?.camera?.remoteIndex,
            width,
            height,
          });
          if (Number.isInteger(camera?.camera?.id)) {
            DataControllerManager.getDb().then((db) => {
              try {
                db.put(DB_STORE.SNAPSHOT, {
                  id: +camera.camera?.id,
                  imageBlob: blob,
                  width: width,
                  height: height,
                });
                console.log("lzctest:Put snapshot success", camera.camera?.id);
              } catch (error) {
                console.log("put snapshot error:", error);
              }

              canvas.remove();
            });
          }
        });
      }
    });
  }

  //will return same promise if multiple requests for same nvr at same time
  async createDataController(nvrId: number, orgId?: string) {
    let connectingPromise = this.connectingController.get(nvrId);
    if (!connectingPromise) {
      connectingPromise = new Promise(async (actualResolve, actualReject) => {
        const creationSingleton = (attempt = 0): Promise<DataController> => {
          return new Promise(async (resolve, reject) => {
            let credential = this.dataCredentials.find(
              (credential) =>
                +credential.deviceId === nvrId &&
                !this.credentialTokenExpired(credential),
            );
            // let cookieOrgId = Cookies.get("orgId");
            // if (cookieOrgId === "undefined") cookieOrgId = null;
            if (!credential) {
              try {
                console.log(
                  "DataControllerManager.orgId,nvrId",
                  DataControllerManager.orgId,
                  nvrId,
                );
                const res = await batchObtainCredentials(
                  orgId || DataControllerManager.orgId,
                  DataControllerManager.sessionId,
                  [nvrId],
                );
                if (
                  !res ||
                  !Array.isArray(res.tokens) ||
                  res.tokens.length === 0
                ) {
                  reject(new Error("Invalid response"));
                  return;
                }
                this.dataCredentials.push(...res.tokens);
                credential = res.tokens[0];
              } catch (error) {
                console.error("error to fetch credentials", error);
                reject(new Error("Invalid response"));
                return;
              }
            }

            const rtcToken = credential.token;
            const turn = credential.turn;
            // this function is called when closed and error occured
            const onErrorRetry = (err) => {
              console.log("onClose", err);
              if (err === "normal") {
                return void 0;
              }
              if (attempt > retryLimit) {
                this.removeDataController(nvrId);
                this.connectingController.delete(nvrId);
                reject(err);
                return void 0;
              } else {
                console.log("retry attempt: ", attempt);
                creationSingleton(++attempt)
                  .then((controller) => {
                    resolve(controller);
                  })
                  .catch((e) => {
                    reject(e);
                  });
              }
            };
            console.log(
              "orgId,dm orgId,nvrId",
              orgId,
              DataControllerManager.orgId,
              nvrId,
            );
            const dataController = new DataController({
              orgId: orgId ? Number(orgId) : +DataControllerManager.orgId,
              nvrId: +nvrId,
              signal: DataControllerManager.signal,
              turn: turn,
              rtcToken,
              debugging: Boolean(ENV === "development"),
              errorHandler,
            });
            let eventReady = false;
            let extraChlReady = false;
            let connected = false;
            dataController.addEventListener(
              DataController.EVENT_READY,
              async () => {
                eventReady = true;
                if (extraChlReady && connected) {
                  console.log("dataController full ready");
                  this.connectingController.delete(nvrId);

                  resolve(dataController);
                }
              },
            );
            dataController.webRTC.addEventListener(
              WebRTC.EVENT_MESSAGE_OPEN,
              async () => {
                connected = true;
                if (extraChlReady && eventReady) {
                  console.log("dataController full ready");
                  this.connectingController.delete(nvrId);

                  resolve(dataController);
                }
              },
            );
            dataController.webRTC.addEventListener(
              DataWebRTC.EXTRA_CHANNEL_CONNECTED,
              async () => {
                extraChlReady = true;
                if (connected && eventReady) {
                  console.log("dataController full ready");
                  this.connectingController.delete(nvrId);
                  resolve(dataController);
                }
              },
            );
            dataController.webRTC.addEventListener(
              DataWebRTC.EVENT_DEVICE_SNAPSHOTS,
              this.snapshotToDb,
            );
            dataController.addEventListener(
              DataController.EVENT_CLOSE,
              onErrorRetry,
            );

            dataController.start();
            console.log("dataControlers start", dataController.connectId);
          });
        };
        try {
          const dataController = await creationSingleton(1);
          actualResolve(dataController);
        } catch (e) {
          actualReject(e);
        }
      });
      //save promise singleton for further use
      this.connectingController.set(nvrId, connectingPromise);
    }
    return connectingPromise;
  }
}

export default DataControllerManager;
